import React from "react";
import { SetStringState, SetBoolState } from "./MarginMarkupToggle";

function useToggleSelector(
  setMarginInput: SetStringState,
  setWithMarkup: SetBoolState,
  fixedMargin: string | null,
  fixedMarkup: string | null
) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;

    setWithMarkup(checked);

    if (checked && fixedMarkup) {
      setMarginInput(fixedMarkup);
    } else if (!checked && fixedMargin) {
      setMarginInput(fixedMargin);
    }
  };

  return {
    handleChange,
  };
}

export default useToggleSelector;
